import React from 'react';

import PropTypes from 'prop-types';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import { HeaderTitle } from '@src/components/common';
import productAddResources from '@src/global/productAddResources';

import { Links } from './links';
import { ProductLinks } from './ProductLinks';

import './ProductHome.scss';

const Home = ({ productList }) => {
    return (
        <Col id="home-index-products">
            <HeaderTitle
                title="Products"
            />
            <Row>
                <Col className="main-container-row">
                    <ProductLinks
                        className="main-container-row"
                        products={productList}
                    />
                </Col>
            </Row>
            <Row className="additional-resources title">
                <Col className="text-center">
                    <h2>Additional Resources</h2>
                </Col>
            </Row>
            <Row className="additional-resources links">
                <Col className="text-center main-container-row">
                    <Links
                        className="additional-resources"
                        products={productAddResources}
                    />
                </Col>
            </Row>
        </Col>
    );
};

Home.propTypes = {
    productList: PropTypes.arrayOf(PropTypes.object),
};

export default Home;
